import { useQuery } from '@tanstack/react-query'
import { isTier2 } from '../api-clients/swarm/passport'

const useTier2 = (address?: string) => {
  return useQuery({
    queryFn: () => isTier2(),
    queryKey: ['tier2', address],
  })
}

export default useTier2
